
<template>
  <div id="page-holiday-list">
    <vs-card>



      <div v-if="selectedItems.length > 0">
        <vs-button @click="saveSelected('approve')" color="success" class="mr-2" size="small">Aprovar</vs-button>
        <vs-button @click="saveSelected('reject')" color="danger" size="small">Reprovar</vs-button>
      </div>

      <vs-table search stripe :data="shifts" :max-items="paginate">

        <template slot="thead">
          <vs-th style="background-color: #ebe9f1; width: 50px;">
            <input type="checkbox" @click="selectAll" v-model="selectAllCheckbox" />
          </vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="employee">Nome</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="start_date">Data</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="end_date">Hora Inicio</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="end_date">Hora Fim</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="end_date">Hora de Almoço</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="end_date">Fim de Almoço</vs-th>
          <vs-th style="background-color: #ebe9f1;" sort-key="status">Estado</vs-th>
          <vs-th style="background-color: #ebe9f1;">Acções</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="(item, index) in data" :key="index">
            <vs-td><input type="checkbox" v-model="selectedItems" :value="item" /></vs-td>
            <vs-td>{{ item.employee.user.name }} {{ item.employee.user.surname }}</vs-td>
            <vs-td>{{ (item.shift ? item.shift.name : 'Folga') }}</vs-td>
            <vs-td>{{ (item.date) }}</vs-td>
            <vs-td>{{ (item.shift ? item.shift.start_time : '-') }}</vs-td>
            <vs-td>{{ (item.shift ? item.shift.end_time : '-') }}</vs-td>
            <vs-td>{{ (item.shift ? item.shift.end_lunch_time : '-') }}</vs-td>

            <vs-td>
              <vs-pill style="padding: 5px; border-radius: 4px; font-family: 'Arial', sans-serif; font-size: 12px; "
                :class="getStatusClass(item.status)">{{ getStatusName(item.status) }}</vs-pill>
            </vs-td>
            <vs-td>
              <vs-dropdown v-if="item.status == 'pending'" vs-custom-content vs-trigger-click class="cursor-pointer">
                <feather-icon icon="MenuIcon" svg-classes="h-4 w-4" class="ml-4 mr-4"></feather-icon>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="clickApproveHandler(item)">
                    <span class="flex items-center">
                      <feather-icon icon="CheckIcon" svgClasses="h-4 w-4" class="mr-2" />
                      <span>Aprovar</span>
                    </span>
                  </vs-dropdown-item>

                  <vs-dropdown-item @click="clickRejectHandler(item)">
                    <span class="flex items-center">
                      <feather-icon icon="XIcon" svgClasses="h-4 w-4" class="mr-2 " />
                      <span class="">Rejeitar</span>
                    </span>
                  </vs-dropdown-item>




                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>

          </vs-tr>
        </template>


      </vs-table>


      <div class="flex justify-between items-center">
        <label style="font-family: 'Arial', sans-serif; font-size: 13px; margin-left: 5px;" class="font-light">Mostrando
          {{ total }} de {{ perPage }} </label>
        <vs-pagination class="flex-1" style="margin-top: 10px;" v-model="currentPage" :total="lastPage" :per-page="perPage" @change="getVacations"
          :size="size" color="primary" :gradient="gradient" :rounded="rounded" :dense="dense"></vs-pagination>
      </div>





      <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
    </vs-card>


    <vs-popup class="holamundo" title="Aprovar Turno" v-model="popupApprove" :active.sync="popupApprove">

      <b-card-text>
        Tem certeza que deseja aprovar o turno ?
      </b-card-text>

      <div class="flex flex-wrap items-center flex-start">
        <vs-button type="filled" class="ml-auto mt-2" @click="approveVacation">Aprovar</vs-button>
        <vs-button class="ml-4 mt-2" type="filled" @click="popupApprove = false" color="danger">Cancelar</vs-button>
      </div>
    </vs-popup>

    <vs-popup class="holamundo" title="Rejeitar Turno" v-model="popupReject" :active.sync="popupReject">

      <b-card-text>
        Tem certeza que deseja rejeitar o turno ?
      </b-card-text>

      <div class="flex flex-wrap items-center flex-start">
        <vs-button type="filled" class="ml-auto mt-2" @click="rejectVacation">Rejeitar</vs-button>
        <vs-button class="ml-4 mt-2" type="filled" @click="popupReject = false" color="danger">Cancelar</vs-button>
      </div>
    </vs-popup>





  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import http from '../../../../http-common'
import http1 from '../../../../http1-common'
// Store Module

// Cell Renderer

export default {
  components: {
    AgGridVue,
    vSelect,


  },
  data() {
    return {
      shifts: [],
      selectedEmpName: '',
      start_date: '',
      end_date: '',
      status: '',
      employees: [],
      statusOptions: [
        { label: "Aprovado", value: "approved" },
        { label: "Interropido", value: "canceled" },

      ],
      popupPostepone: false,
      popupApprove: false,
      popupConvert: false,
      popupReject: false,
      popupPost: false,
      new_start_date: '',
      new_end_date: '',
      selectAllCheckbox: false, // Variável para marcar/desmarcar todos os checkboxes de seleção
      selectedItems: [], // Array para rastrear os itens selecionados
      reason: '',
      lastPage: 0,
      currentPage: 1,
      perPage: 0, // Number of items to display per page
      total: 0, // Total number of items
      size: 'normal', // Pagination size
      gradient: false, // Enable gradient effect
      rounded: false, // Enable rounded corners
      dense: false, // Use compact pagination style
    }
  },

  mounted() {
    this.initialize();
  },


  computed: {
    formattedStartDate: {
      get() {
        return this.formatDate(this.selectedItem.start_date);
      },
      set(value) {
        // Update the original start_date value if needed
        this.selectedItem.start_date = value;
      },
    },
    formattedEndDate: {
      get() {
        return this.formatDate(this.selectedItem.end_date);
      },

    },
    selectedEmployeeFullName: {
      get() {
        return this.selectedItem.employee.user.name + ' ' + this.selectedItem.employee.user.surname;
      },

    },
  },


  methods: {
    initialize() {
      this.getUser();
      this.getShifts();
      this.getEmployees();
    },

    selectAll() {
      this.selectAllCheckbox = !this.selectAllCheckbox;

      if (this.selectAllCheckbox) {
        this.selectedItems = this.shifts.slice(); // Selecionar todos os itens
        console.log(this.selectAllCheckbox)
      } else {
        this.selectedItems = []; // Desselecionar todos os itens
      }
    },

    handleEmployeeChange() {
      if (this.selectedEmployee === "Edy Barrote") {
        alert("Edy Barrote");
      }
    },

    fillterStatus() {
      alert(this.status);
    },

    getUser() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type: 'sound'
      })



      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params: {
          type: 1
        }
      };

      http
        .get("/users/users", config)
        .then((result) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.users = result.data.Users.reverse();

          // alert("2")
        })
        .catch((error) => {

          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    clickApproveHandler(item) {
      this.popupApprove = true;
      this.selectedItem = item;
    },
    clickRejectHandler(item) {
      this.popupReject = true;
      this.selectedItem = item;
    },

    clickConvertHandler(item) {
      // Display the popup model and pass the data from the current row
      this.popupConvert = true;
      this.selectedItem = item; // Store the current row data in a variable for display in the popup
    },

    clickPostponeHandler(item) {
      // Display the popup model and pass the data from the current row
      this.popupPost = true;
      this.selectedItem = item; // Store the current row data in a variable for display in the popup
    },
    getShifts() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type: 'sound'
      })



      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params: {
          start_date: this.start_date,
          end_date: this.end_date,
          status: this.status.value,
          page: this.currentPage,
          paginate: this.paginate,
        }
      };

      http1
        .get("/shifts/assignment/list/shift", config)
        .then((result) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.shifts = result.data.data;

          this.currentPage = result.data.current_page
          this.perPage = result.data.per_page
          this.total = result.data.total
          this.lastPage = result.data.last_page
          console.log('Shifits', this.shifts);
          // alert("2")
        })
        .catch((error) => {

          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { day: "numeric", month: "long", year: "numeric" };
      return date.toLocaleDateString("pt-PT", options); // Adjust the locale as needed
    },

    getStatusClass(status) {
      if (status === 'approved') {
        return 'vs-pill-success';
      } else if (status === 'pending') {
        return 'vs-pill-warning';
      } else if (status === 'rejected') {
        return 'vs-pill-danger';
      } else if (status === 'canceled') {
        return 'vs-pill-dark';
      }

      else {
        return '';
      }
    },

    getStatusName(status) {
      if (status === 'approved') {
        return 'Aprovado';
      } else if (status === 'pending') {
        return 'Pendente';
      } else if (status === 'rejected') {
        return 'Rejeitado';
      } else if (status === 'canceled') {
        return 'Cancelado';
      }

      else {
        return '';
      }
    },

    getTypeClass(type) {
      if (type === 'Singular') {
        return 'vs-pill-primary';
      } else if (type === 'Colectivas') {
        return 'vs-pill-secundary';
      } else {
        return '';
      }
    },
    getEmployees() {


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },

      };

      http1
        .get("/employees", config)
        .then((result) => {
          this.employees = result.data.data;


        })
        .catch((error) => {
          console.log('Employee', error);

        });
    },


    approveVacation() {
      this.$vs.loading()
      setTimeout(() => {
        this.$vs.loading.close()
      }, 3000);
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        status: 'approved',
        shift_id: this.selectedItem.shift_id,
      };

      this.popupApprove = false

      this.$validator.validateAll();
      http1
        .put("/shifts/assignment/shift/" + this.selectedItem.id, data, config)
        .then((success) => {
          success;
          this.reason = '';
          this.$vs.loading.close();
          this.popupApprove = false;
          this.$vs.notify({
            title: "Sucesso",
            text: "Turno aprovado com sucesso",
            color: "success",
            position: "top-right",
          });

          this.getShifts()


        })
        .catch((error) => {
          error;
          console.log("Error", error)
          this.err = error.response.data
          this.$vs.loading.close()
          this.$vs.notify({
            title: "Erro",
            text: this.err.message,
            color: "danger",
            position: "top-right",
          })
        });
    },

    multiApproveVacation(item) {
      
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        status: 'approved',
        shift_id: item.shift_id,
      };


      this.$validator.validateAll();
      http1
        .put("/shifts/assignment/shift/" + item.id, data, config)
        .then((success) => {
          success;
          this.reason = '';
          this.popupApprove = false;
          this.$vs.notify({
            title: "Sucesso",
            text: "Turno aprovado com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          console.log("Error", error)
          this.err = error.response.data
          this.$vs.notify({
            title: "Erro",
            text: this.err.message,
            color: "danger",
            position: "top-right",
          })


        });
    },

    rejectVacation() {
      this.$vs.loading()
      
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        status: 'rejected',
        shift_id: this.selectedItem.shift_id,
      };

      this.popupReject = false


      this.$validator.validateAll();
      http1
        .put("/shifts/assignment/shift/" + this.selectedItem.id, data, config)
        .then((success) => {
          success;
          this.reason = '';
          this.$vs.loading.close();
          this.popupApprove = false;
          this.$vs.notify({
            title: "Sucesso",
            text: "Turno rejeitado com sucesso",
            color: "success",
            position: "top-right",
          });

          this.getShifts()

        })
        .catch((error) => {
          error;
          console.log("Error", error)
          if (error.response.status == 422) {
            this.err = error.response.data
            this.$vs.loading.close()
            this.$vs.notify({
              title: "Sucesso",
              text: this.err,
              color: "danger",
              position: "top-right",
            })
          } else if (error.response.status == 200) {
            this.err = error.response.data
            this.$vs.loading.close()
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          } else {
            this.$vs.loading.close();

            this.$vs.notify({
              title: "Erro",
              text: error.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }

        });
    },

    multiRejectVacation(item) {
      this.$vs.loading()
      setTimeout(() => {
        this.$vs.loading.close()
      }, 3000);
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        status: 'rejected',
        shift_id: item.shift_id,
      };

      this.$validator.validateAll();
      http1
        .put("/shifts/assignment/shift/" + item.id, data, config)
        .then((success) => {
          success;
          this.reason = '';
          this.$vs.loading.close();
          this.popupApprove = false;
          this.$vs.notify({
            title: "Sucesso",
            text: "Turno rejeitado com sucesso",
            color: "success",
            position: "top-right",
          });

        })
        .catch((error) => {
          error;
          console.log("Error", error)
          this.err = error.response.data
          this.$vs.loading.close()
          this.$vs.notify({
            title: "Erro",
            text: this.err.message,
            color: "danger",
            position: "top-right",
          })

        });
    },

    async saveSelected(type) {
      console.log("Itens selecionados para exclusão:", this.selectedItems);
      this.$vs.loading()

      if (type === "approve") {
        for (const item of this.selectedItems) {
          await this.multiApproveVacation(item);
          console.log("Item aprovado:", item);
        }
        
      } else {
        for (const item of this.selectedItems) {
          await this.multiRejectVacation(item);
          console.log("Item aprovado:", item);
        }

        
      }

      this.$vs.loading.close()
      this.getShifts()

      this.selectAllCheckbox = false;
      this.selectedItems = []

      

    },





  }
}

</script>

<style>
/* Add styles for the pill colors */
.vs-pill-success {
  background-color: #28CF6F;
  color: white;
  padding: 5px;
}

.vs-pill-danger {
  background-color: #EA5455;
  color: white;
}

.vs-pill-warning {
  background-color: rgb(255, 159, 67);
  color: white;
}

.vs-pill-dark {
  background-color: rgb(168, 170, 174);
  color: white;
}

.vs-pill-primary {
  background-color: #00CFE8;
  color: white;
}

.vs-pill-secundary {
  background-color: #A8AAAC;
  color: white;
}
</style>
